import _asyncToGenerator from "F:/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue";
var _hoisted_1 = {
  class: "dialog_client_box"
};
var _hoisted_2 = {
  style: {
    "display": "flex"
  }
};
var _hoisted_3 = {
  style: {
    "flex": "1"
  }
};
var _hoisted_4 = ["disabled"];
var _hoisted_5 = {
  class: "dialog-footer"
};
import { ref, watch, watchEffect, computed, reactive } from "vue";
import { client, get_dictionary, sales_area, get_zone_member, set_client, getcustomTypeInfo, get_sale_staff_by_jd, get_sale_area_group } from "@/api/apis";
import { useUserStore } from "@/store/user";
import { useDicStore } from "@/store/dictionary";
import { ElMessage } from "element-plus";
import _ from "lodash";
import { time } from "echarts";
import { phone_reg } from "@/util";
export default {
  __name: 'addClientDailog',
  props: ["id", "isShow", "info", "goods"],
  emits: ["close", "onSetSuccess"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emit = __emit;
    var userStore = useUserStore();
    var userDic = useDicStore();
    var ruleFormRef = ref(null);
    var isCustomerStatusDisabled = computed(() => {
      return !!props.id; // 编辑状态下禁用
    });
    var default_client = {
      company: "",
      customer_status: "",
      // 客户状态
      area: "",
      // 所在地区
      type: "",
      // 客户类型
      tax_id: "",
      // 税号
      contact_person: "",
      // 主要联系人
      contact_person_id: "",
      // 主要联系人iD
      mobile: "",
      // 手机
      contact_email: "",
      // 联系人邮箱
      email: "",
      // 邮箱
      trade: "",
      // 行业
      classification: "",
      // 客户分级
      parent_client_id: "",
      address: "",
      // 公司地址
      register_address: "",
      // 注册地址
      make_invoice_address: "",
      // 开票地址
      take_goods_address: "",
      // 收货地址
      remark: "",
      company_phone: "",
      // 客户电话
      province: "",
      // 省市区
      country: "",
      // 国家
      stage: "",
      // 客户阶段
      sn: "",
      // 编号
      sales_dept_id: "",
      userid: "",
      // 销售员的id
      entrusted_agent: "",
      // 委托代理人
      header: "",
      //发票抬头
      delivery_header: "",
      //收货抬头
      delivery_person: "",
      //收货人
      delivery_phone: "",
      //收货电话
      contract_person: "",
      //合同发送人
      contract_phone: "",
      //合同联系电话
      contract_address: "",
      //合同地址
      client_type: "",
      //客户分类
      payment: "",
      //付款方式
      deposit_bank: "",
      //开户银行
      bank_account: "",
      //银行账号
      invoice_contact_number: "",
      //开票联系电话
      social_credit_code: "",
      //统一社会信用代码
      special_require: "",
      //特殊要求
      is_erp: 0,
      //是否同步金蝶
      client_type: "",
      //客户分类
      client_type_number: "",
      //客户分类 number
      client_group: "",
      //客户分组 --地区
      client_group_number: "",
      //客户分组 number
      client_level: "",
      //客户等级
      client_level_number: "",
      //客户等级 number
      projects: [],
      is_distributor: 2,
      sale_org: "",
      // 销售组织名称
      sale_org_number: "17" // 销售组织编码，默认为17
    };
    var form = ref();
    form.value = Object.assign({}, default_client);
    function validatePhone(rule, value, callback) {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!phone_reg(value)) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    }
    var rules = {
      customer_status: [{
        required: "true",
        message: "请选择客户状态",
        trigger: ["blur", "change"]
      }],
      area: [{
        required: "true",
        message: "请选择所在地区",
        trigger: ["blur", "change"]
      }],
      client_level: [{
        required: "true",
        message: "请选择客户类型",
        trigger: ["blur", "change"]
      }],
      company: [{
        required: "true",
        message: "请输入客户名称",
        trigger: ["blur", "change"]
      }],
      contact_person: [{
        required: "true",
        message: "请输入或选择主要联系人",
        trigger: ["blur", "change"]
      }],
      mobile: [{
        validator: validatePhone,
        required: true,
        trigger: "blur"
      }],
      contact_email: [{
        required: "true",
        message: "请输入联系人邮箱",
        trigger: ["blur", "change"]
      }],
      sales_dept_id: [{
        required: "true",
        message: "请选择销售区域",
        trigger: ["blur", "change"]
      }],
      userid: [{
        required: "true",
        message: "请选择销售员",
        trigger: ["blur", "change"]
      }],
      area: [{
        required: "true",
        message: "请选择所在地区",
        trigger: ["blur", "change"]
      }]
    };
    var dialogVisible = ref(false);
    var is_show_dialog = ref(false);
    var data_type = ref(""); // 进行选择数据的字段

    // 销售组织列表
    var sales_group_list = ref([]);
    // 销售员列表（通过销售组织获取）
    var user_list = ref([]);

    // 根据销售组织id 获取金蝶下的操作员 即销售员列表
    var getJDUserListBySalesDeptId = number => {
      return new Promise(resolve => {
        get_sale_staff_by_jd({
          number: number
        }).then(res => {
          user_list.value = res.data || [];
          // 同时更新dic_data中的销售员列表，保持兼容性
          dic_data.sales_user_list = res.data || [];
          resolve(res.data || []);
        });
      });
    };

    // 初始化销售组织列表
    var initSalesGroupList = () => {
      return new Promise(resolve => {
        get_sale_area_group().then(res => {
          sales_group_list.value = res.data.data || [];
          resolve(sales_group_list.value);
        });
      });
    };

    // 设置默认销售组织和加载销售员列表
    var setDefaultSalesOrg = () => {
      var orgNumber = "17";
      var orgName = "";
      var defaultOrg = sales_group_list.value.find(item => item.FNumber === "17");
      if (defaultOrg) {
        orgNumber = "17";
        orgName = defaultOrg.FName;
      } else if (sales_group_list.value.length > 0) {
        orgNumber = sales_group_list.value[0].FNumber;
        orgName = sales_group_list.value[0].FName;
      }

      // 只有在没有现有销售组织时才设置默认值
      if (!form.value.sale_org_number) {
        form.value.sale_org_number = orgNumber;
        form.value.sale_org = orgName;

        // 加载对应的销售员列表
        getJDUserListBySalesDeptId(orgNumber);
      }
    };

    // 销售组织改变时的处理函数
    var handleChangeSeller = e => {
      var currentUserId = form.value.userid; // 保存当前选中的销售员
      form.value.sale_org_number = e;

      // 根据销售组织获取销售员列表
      getJDUserListBySalesDeptId(e).then(userList => {
        // 检查当前选中的销售员是否在新的销售员列表中
        var userExists = userList.some(user => user.user_id == currentUserId);
        if (!userExists) {
          // 如果当前销售员不在新列表中，才清空选择
          form.value.userid = "";
        }
      });

      // 设置销售组织名称
      var selectedOrg = sales_group_list.value.find(item => item.FNumber === e);
      if (selectedOrg) {
        form.value.sale_org = selectedOrg.FName;
      }
    };
    var init_from = () => {
      var _obj$contact_person_i, _obj$contact_person_i2, _obj$contact_person_i3, _obj$user_info, _obj$user_info2;
      var obj = _.cloneDeep(props.info);

      // 保存当前的销售组织信息，避免被客户数据覆盖
      var currentSaleOrgNumber = form.value.sale_org_number;
      var currentSaleOrg = form.value.sale_org;
      Object.keys(form.value).map(x => {
        if (obj.hasOwnProperty(x)) {
          form.value[x] = obj[x];
        }
      });

      // 如果客户数据中有销售组织信息，使用客户数据；否则保持当前值
      if (obj.sale_org_number) {
        form.value.sale_org_number = obj.sale_org_number;
        form.value.sale_org = obj.sale_org || "";
      } else {
        // 如果客户数据中没有销售组织信息，保持当前值或设置默认值
        form.value.sale_org_number = currentSaleOrgNumber || "17";
        form.value.sale_org = currentSaleOrg || "";
      }
      form.value.contact_person = ((_obj$contact_person_i = obj.contact_person_info) === null || _obj$contact_person_i === void 0 ? void 0 : _obj$contact_person_i.name) || obj.contact_person || "";
      form.value.mobile = ((_obj$contact_person_i2 = obj.contact_person_info) === null || _obj$contact_person_i2 === void 0 ? void 0 : _obj$contact_person_i2.phone) || obj.mobile || "";
      form.value.contact_email = ((_obj$contact_person_i3 = obj.contact_person_info) === null || _obj$contact_person_i3 === void 0 ? void 0 : _obj$contact_person_i3.email) || obj.contact_email || "";

      // 正确设置销售员ID - 需要匹配销售员列表中的user_id字段
      if ((_obj$user_info = obj.user_info) !== null && _obj$user_info !== void 0 && _obj$user_info.user_id) {
        form.value.userid = obj.user_info.user_id;
      } else if ((_obj$user_info2 = obj.user_info) !== null && _obj$user_info2 !== void 0 && _obj$user_info2.id) {
        form.value.userid = obj.user_info.id;
      } else if (obj.userid) {
        form.value.userid = obj.userid;
      }
      goods_list.value = _.cloneDeep([...(obj.goods_ids_list || []), ...(obj.class_ids_list || [])]);
      goods_list_temp.value = _.cloneDeep([...(obj.goods_ids_list || []), ...(obj.class_ids_list || [])]);
      form.value.goods_ids_list = [];

      // 如果有销售组织信息，加载对应的销售员列表
      var finalSaleOrgNumber = form.value.sale_org_number;
      if (finalSaleOrgNumber) {
        getJDUserListBySalesDeptId(finalSaleOrgNumber).then(() => {
          // 销售员列表加载完成后，确保销售员选择正确
          if (form.value.userid) {
            // 检查销售员是否在列表中
            var foundUser = user_list.value.find(user => user.user_id == form.value.userid || user.id == form.value.userid);
            if (!foundUser) {
              form.value.userid = "";
            }
          }
        });
      }
    };
    /**
     * 编辑带来的详情
     */
    watch(() => {
      return props.info;
    }, () => {
      if (!props.info) {
        form.value = Object.assign({}, default_client);
        // 重新设置默认销售组织
        setTimeout(() => {
          setDefaultSalesOrg();
        }, 100);
      } else {
        init_from();
      }
    });
    var handle_goods = val => {
      // console.log("在客户中收到的商品修改的回调===&&&", val);
      // goods_list.value = val;
      goods_list_temp.value = _.cloneDeep(val);
    };

    /**
     * 商品
     */
    /**
     * 关联商品
     */
    var goods_list = ref([]);
    var goods_list_temp = ref([]);
    watch(() => {
      return props.goods;
    }, val => {
      goods_list.value = _.cloneDeep(val);
      goods_list_temp.value = _.cloneDeep(val);
      // console.log("client打印商品列表=====", goods_list.value);
    });
    watchEffect(() => {
      dialogVisible.value = props.isShow;
    });
    watch(() => {
      return dialogVisible.value;
    }, () => {
      if (!dialogVisible.value) {
        form.value = Object.assign({}, default_client);
        ruleFormRef.value.resetFields();
        goods_list.value = [];
        goods_list_temp.value = [];
        user_list.value = [];
        emit("close");
      } else {
        if (props.info) {
          init_from();
        } else {
          // 新增模式，设置默认销售组织
          setTimeout(() => {
            setDefaultSalesOrg();
          }, 100);
        }
      }
    });
    var changeSelect = (e, keynumber) => {
      var list = [];
      if (keynumber == "client_type_number" || keynumber == "payment_number") {
        var _list$find;
        keynumber == "payment_number" ? list = dic_data.payment : list = dic_data.clientType_list;
        form.value[keynumber] = (_list$find = list.find(x => x.full_name == e)) === null || _list$find === void 0 ? void 0 : _list$find.encode;
      } else {
        if (keynumber == "client_level") {
          getcustomTypeInfo({
            client_level: e
          }).then(res => {
            Object.keys(res.data).forEach(key => {
              form.value[key] = res.data[key];
            });
          });
        }
      }
    };
    var select_data = val => {
      data_type.value = val;
      is_show_dialog.value = true;
    };
    var get_select_item = val => {
      is_show_dialog.value = false;
      if (data_type.value == "联系人") {
        form.value.contact_person_id = val.id;
        form.value.contact_person = val.name;
        form.value.mobile = val.phone;
        form.value.contact_email = val.email || "暂无";
      }
    };
    var projectItemRef = ref(null);
    var onSubmit = () => {
      ruleFormRef.value.validate(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(function* (valid) {
          if (valid) {
            // form.value.salename = dic_data.sales_user_list.find(
            //   (x) => x.id == form.value.userid
            // )?.name;
            var projectValid = true;
            if (projectItemRef.value && projectItemRef.value.validateTable) {
              projectValid = yield projectItemRef.value.validateTable();
            }

            // 如果项目信息校验不通过，则不提交
            if (!projectValid) {
              ElMessage({
                type: "warning",
                message: "请完善项目信息"
              });
              return;
            }
            var obj = _.cloneDeep(form.value);
            var method = "post";
            if (props.id) {
              method = "put";
              obj.id = props.id;
            }
            obj.goods_ids = (goods_list_temp.value && goods_list_temp.value.filter(x => x.category).map(x => {
              return x.id;
            })).join(",") || "";
            obj.class_ids = (goods_list_temp.value && goods_list_temp.value.filter(x => !x.category).map(x => {
              return x.id;
            })).join(",") || "";
            // obj["goods_ids_list"] =
            //   ||
            //   [];

            set_client(obj, method).then(res => {
              if (res.code == 200) {
                ElMessage({
                  type: "success",
                  message: props.id ? "编辑客户成功" : "新增客户成功"
                });
                dialogVisible.value = false;
                emit("onSetSuccess");
              }
            });
          }
        });
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    };
    var dic_data = reactive({
      arealist: [],
      // 地区
      // typelist: [], // 客户类型
      tradelist: [],
      // 行业
      statuslist: [],
      // 客户阶段
      client_status_list: [],
      // 客户状态
      classification_list: [],
      // 客户分级
      sales_area_list: [],
      sales_user_list: [],
      payment: [],
      //付款方式
      client_level: [],
      //客户类型
      clientType_list: [],
      client_level_number: []
    });

    // 移除原来的销售区域监听，因为现在使用销售组织获取销售员
    // watch(
    //   () => {
    //     return form.value.sales_dept_id;
    //   },
    //   () => {
    //     if (form.value.sales_dept_id) {
    //       get_zone_member({ sales_dept_id: form.value.sales_dept_id }).then(
    //         (res) => {
    //           dic_data.sales_user_list = res.data.sales_user_list || [];
    //           const isClear = ref(true);
    //           res.data.sales_user_list.map((item) => {
    //             if (item.id == form.value.userid) {
    //               isClear.value = false;
    //             }
    //           });
    //           if (isClear.value) {
    //             form.value.userid = "";
    //           }
    //         }
    //       );
    //     }
    //   }
    // );
    userStore.getInfo().then(res => {
      var _userStore$info;
      sales_area({
        interface: "get_user_data_auth_detail",
        group_type: 1,
        userid: (_userStore$info = userStore.info) === null || _userStore$info === void 0 ? void 0 : _userStore$info.id,
        page: 1,
        limit: 240
      }).then(res => {
        if (res.code == 200) {
          dic_data.sales_area_list = Object.values(res.data.list);
        }
      });
    });
    userDic.get_dic("行业").then(res => {
      dic_data.tradelist = res;
    });
    userDic.get_dic("地区").then(res => {
      dic_data.arealist = res;
    });
    userDic.get_dic("客户类型").then(res => {
      dic_data.typelist = res;
    });
    userDic.get_dic("客户阶段").then(res => {
      dic_data.statuslist = res;
    });
    userDic.get_dic("客户状态").then(res => {
      dic_data.client_status_list = res;
    });
    userDic.get_dic("客户分级").then(res => {
      dic_data.classification_list = res;
    });
    userDic.get_dic("客户分类--erp").then(res => {
      dic_data.clientType_list = res;
    });
    userDic.get_dic("客户类型-erp").then(res => {
      dic_data.clientLevel_list = res;
    });
    userDic.get_dic("客户种类-销售订单").then(res => {
      dic_data.client_level = res;
    });
    userDic.get_dic("客户等级").then(res => {
      dic_data.client_level_number = res;
    });
    userDic.get_dic("付款方式-erp").then(res => {
      dic_data.payment = res;
    });
    var handleProjectDataUpdate = val => {
      form.projects = val;
    };

    // 初始化销售组织和销售员数据
    var initializeComponent = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(function* () {
        // 先初始化销售组织列表
        yield initSalesGroupList();

        // 如果没有客户信息（新增模式），设置默认销售组织
        if (!props.info) {
          setDefaultSalesOrg();
        }
      });
      return function initializeComponent() {
        return _ref3.apply(this, arguments);
      };
    }();

    // 组件初始化
    initializeComponent();
    return (_ctx, _cache) => {
      var _component_el_option = _resolveComponent("el-option");
      var _component_el_select = _resolveComponent("el-select");
      var _component_el_form_item = _resolveComponent("el-form-item");
      var _component_el_col = _resolveComponent("el-col");
      var _component_el_input = _resolveComponent("el-input");
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_row = _resolveComponent("el-row");
      var _component_add_project_item = _resolveComponent("add-project-item");
      var _component_el_form = _resolveComponent("el-form");
      var _component_good_list_table = _resolveComponent("good-list-table");
      var _component_el_dialog = _resolveComponent("el-dialog");
      var _component_select_data = _resolveComponent("select-data");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => dialogVisible.value = $event),
        title: __props.id ? '编辑客户' : '新增客户',
        width: "1000px",
        "append-to-body": true,
        top: "70px",
        class: "s-client-dialog",
        style: {
          width: '1000px',
          maxHeight: 'calc(100vh - 30px)',
          overflowY: 'auto',
          padding: '20px'
        }
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_5, [_createVNode(_component_el_button, {
          onClick: _cache[37] || (_cache[37] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => _cache[77] || (_cache[77] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: onSubmit,
          color: "#248f83"
        }, {
          default: _withCtx(() => _cache[78] || (_cache[78] = [_createTextVNode(" 确定 ")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          model: form.value,
          "label-position": "right",
          rules: rules,
          "label-width": "130px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[40] || (_cache[40] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "客户状态",
                prop: "customer_status"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: form.value.customer_status,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.customer_status = $event),
                  class: "m-2",
                  placeholder: "",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dic_data.client_status_list, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.full_name,
                      value: item.full_name
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[41] || (_cache[41] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "客户名称",
                prop: "company"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.company,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.company = $event),
                  autocomplete: "off",
                  disabled: isCustomerStatusDisabled.value
                }, null, 8, ["modelValue", "disabled"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[42] || (_cache[42] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "客户类型",
                prop: "client_level"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  onChange: _cache[2] || (_cache[2] = $event => changeSelect($event, 'client_level')),
                  modelValue: form.value.client_level,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.client_level = $event),
                  class: "m-2",
                  placeholder: "",
                  filterable: "",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dic_data.client_level, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.full_name,
                      value: item.full_name
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[44] || (_cache[44] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "主要联系人",
                prop: "contact_person"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
                  modelValue: form.value.contact_person,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.contact_person = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]), _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[5] || (_cache[5] = $event => select_data('联系人')),
                  color: "#248f83"
                }, {
                  default: _withCtx(() => _cache[43] || (_cache[43] = [_createTextVNode("选择")])),
                  _: 1
                })])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[45] || (_cache[45] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "联系人手机",
                prop: "mobile"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.mobile,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.mobile = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[46] || (_cache[46] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "联系人邮箱",
                prop: "contact_email"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.contact_email,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.value.contact_email = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[47] || (_cache[47] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "销售区域",
                prop: "sales_dept_id"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: form.value.sales_dept_id,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.value.sales_dept_id = $event),
                  class: "m-2",
                  placeholder: "",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dic_data.sales_area_list, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[48] || (_cache[48] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "销售员",
                prop: "userid"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: form.value.userid,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.value.userid = $event),
                  class: "m-2",
                  placeholder: "请选择销售员",
                  filterable: "",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user_list.value, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.user_id,
                      label: item.fname,
                      value: item.user_id
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _cache[72] || (_cache[72] = _createElementVNode("div", {
            class: "title"
          }, "项目信息", -1)), _createVNode(_component_el_row, {
            gutter: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_add_project_item, {
                data: form.value.projects,
                onOnUpdate: handleProjectDataUpdate,
                ref_key: "projectItemRef",
                ref: projectItemRef
              }, null, 8, ["data"])]),
              _: 1
            })]),
            _: 1
          }), _cache[73] || (_cache[73] = _createElementVNode("div", {
            class: "titleyuejie"
          }, "开票信息", -1)), _createVNode(_component_el_row, {
            gutter: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[49] || (_cache[49] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "发票抬头"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.header,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => form.value.header = $event),
                  autocomplete: "off",
                  disabled: isCustomerStatusDisabled.value
                }, null, 8, ["modelValue", "disabled"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[50] || (_cache[50] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "纳税登记号"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.tax_id,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => form.value.tax_id = $event),
                  autocomplete: "off",
                  disabled: isCustomerStatusDisabled.value
                }, null, 8, ["modelValue", "disabled"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createElementVNode("div", {
                class: "grid-content ep-bg-purple",
                disabled: isCustomerStatusDisabled.value
              }, null, 8, _hoisted_4), _createVNode(_component_el_form_item, {
                label: "开户银行"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.deposit_bank,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => form.value.deposit_bank = $event),
                  autocomplete: "off",
                  disabled: isCustomerStatusDisabled.value
                }, null, 8, ["modelValue", "disabled"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[51] || (_cache[51] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "银行账号"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.bank_account,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => form.value.bank_account = $event),
                  autocomplete: "off",
                  disabled: isCustomerStatusDisabled.value
                }, null, 8, ["modelValue", "disabled"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[52] || (_cache[52] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "开票联系电话"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.invoice_contact_number,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => form.value.invoice_contact_number = $event),
                  autocomplete: "off",
                  disabled: isCustomerStatusDisabled.value
                }, null, 8, ["modelValue", "disabled"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[53] || (_cache[53] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "开票通讯地址"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.make_invoice_address,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => form.value.make_invoice_address = $event),
                  autocomplete: "off",
                  disabled: isCustomerStatusDisabled.value
                }, null, 8, ["modelValue", "disabled"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[54] || (_cache[54] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "统一社会信用代码"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.social_credit_code,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => form.value.social_credit_code = $event),
                  autocomplete: "off",
                  disabled: isCustomerStatusDisabled.value
                }, null, 8, ["modelValue", "disabled"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[55] || (_cache[55] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "特殊要求"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.special_require,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => form.value.special_require = $event),
                  autocomplete: "off",
                  disabled: isCustomerStatusDisabled.value
                }, null, 8, ["modelValue", "disabled"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _cache[74] || (_cache[74] = _createElementVNode("div", {
            class: "titleyuejie"
          }, "商务信息", -1)), _createVNode(_component_el_row, {
            gutter: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[56] || (_cache[56] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "收货抬头"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.delivery_header,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => form.value.delivery_header = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[57] || (_cache[57] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "收货人"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.delivery_person,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => form.value.delivery_person = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[58] || (_cache[58] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "收货地址"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.take_goods_address,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => form.value.take_goods_address = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[59] || (_cache[59] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "收货电话"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.delivery_phone,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => form.value.delivery_phone = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[60] || (_cache[60] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "合同发送人"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.contract_person,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => form.value.contract_person = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[61] || (_cache[61] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "合同联系电话"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.contract_phone,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => form.value.contract_phone = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[62] || (_cache[62] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "合同地址"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.contract_address,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => form.value.contract_address = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[63] || (_cache[63] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "收款条件"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  onChange: _cache[25] || (_cache[25] = $event => changeSelect($event, 'payment_number')),
                  modelValue: form.value.payment,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => form.value.payment = $event),
                  class: "m-2",
                  placeholder: "",
                  filterable: "",
                  style: {
                    "width": "100%"
                  },
                  disabled: isCustomerStatusDisabled.value
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dic_data.payment, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.full_name,
                      value: item.full_name
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue", "disabled"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _cache[75] || (_cache[75] = _createElementVNode("div", {
            class: "titleyuejie"
          }, "地址", -1)), _createVNode(_component_el_row, {
            gutter: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[64] || (_cache[64] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "公司地址"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.address,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => form.value.address = $event),
                  autocomplete: "off",
                  disabled: isCustomerStatusDisabled.value
                }, null, 8, ["modelValue", "disabled"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[65] || (_cache[65] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "注册地址"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.register_address,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => form.value.register_address = $event),
                  autocomplete: "off",
                  disabled: isCustomerStatusDisabled.value
                }, null, 8, ["modelValue", "disabled"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _cache[76] || (_cache[76] = _createElementVNode("div", {
            class: "titleyuejie"
          }, "选填选项", -1)), _createVNode(_component_el_row, {
            gutter: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[66] || (_cache[66] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "客户分类"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  onChange: _cache[29] || (_cache[29] = $event => changeSelect($event, 'client_type_number')),
                  modelValue: form.value.client_type,
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => form.value.client_type = $event),
                  class: "m-2",
                  placeholder: "",
                  filterable: "",
                  style: {
                    "width": "100%"
                  },
                  disabled: isCustomerStatusDisabled.value
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dic_data.clientType_list, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.full_name,
                      value: item.full_name
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue", "disabled"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[67] || (_cache[67] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "客户等级"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  onChange: _cache[31] || (_cache[31] = $event => changeSelect($event, 'client_level_number')),
                  modelValue: form.value.client_level_number,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => form.value.client_level_number = $event),
                  class: "m-2",
                  placeholder: "",
                  filterable: "",
                  style: {
                    "width": "100%"
                  },
                  disabled: isCustomerStatusDisabled.value
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dic_data.client_level_number, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.full_name,
                      value: item.full_name
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue", "disabled"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[68] || (_cache[68] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "委托代理人"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.entrusted_agent,
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => form.value.entrusted_agent = $event),
                  autocomplete: "off",
                  disabled: isCustomerStatusDisabled.value
                }, null, 8, ["modelValue", "disabled"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[69] || (_cache[69] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "编号"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.sn,
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => form.value.sn = $event),
                  autocomplete: "off",
                  disabled: isCustomerStatusDisabled.value
                }, null, 8, ["modelValue", "disabled"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[70] || (_cache[70] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "客户电话"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.company_phone,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => form.value.company_phone = $event),
                  autocomplete: "off",
                  disabled: isCustomerStatusDisabled.value
                }, null, 8, ["modelValue", "disabled"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 8
            }, {
              default: _withCtx(() => [_cache[71] || (_cache[71] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "邮箱"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.email,
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = $event => form.value.email = $event),
                  autocomplete: "off",
                  disabled: isCustomerStatusDisabled.value
                }, null, 8, ["modelValue", "disabled"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"]), _createVNode(_component_good_list_table, {
          goods: goods_list.value,
          onChange_goods: handle_goods
        }, null, 8, ["goods"])])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_select_data, {
        onClose: _cache[39] || (_cache[39] = $event => is_show_dialog.value = false),
        isShow: is_show_dialog.value,
        data_type: data_type.value,
        onOnSelectItem: get_select_item
      }, null, 8, ["isShow", "data_type"])]);
    };
  }
};